module.exports = __webpack_public_path__ + "static/media/evolution_67.fc4e7fbd.svg";